<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div>
    <div
      style="
        font-size: 28px;
        text-align: center;
        font-weight: bold;
        margin-bottom: 32px;
      "
    >
      个案处理摘要
    </div>
    <div v-html="html"></div>
    <div
      style="
        font-size: 26px;
        border: 2px dashed #c0bec7;
        margin-top: 32px;
        padding: 24px 32px;
      "
    >
      根据个案处理摘要显示，“性别”中“男”的个案数为10个，有效百分比为47.62%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为10个，总计个案数百分比为100.00%；“性别”中“女”的有效个案数为11个，有效百分比为52.38%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为11个，总计个案数百分比为100.00%；“年龄”中“18-30岁”的个案数为6个，有效百分比为28.57%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为6个，总计个案数百分比为100.00%，“年龄”中“31-40岁”的有效个案数为8个，有效百分比为38.10%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为8个，总计个案数百分比为100.00%，“年龄”中“41岁以上”的有效个案数为7个，有效百分比为33.33%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为7个，总计个案数百分比为100.00%。
    </div>
  </div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'case-table-4';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$gap: 8pt;
$borderWidth: 2pt;
$borderColor: #c0bec7;
$border: $borderWidth solid #c0bec7;
$_headerHeight: calc($headerHeight - $gap);
$_bodyHeight: calc($bodyHeight + $gap);
.case-table-4 {
  thead {
    tr {
      height: $_headerHeight;
      th {
        height: $_headerHeight;
      }
      &::after {
        @include _custom_table_bg;
        z-index: 1;
        width: calc(100% - $borderWidth * 2);
        height: calc(100%);
        border-left: $border;
        border-right: $border;
        left: 0;
      }
      &:first-child {
        &::after {
          background-color: var(--theme-color-1);
        }
        th {
          & > div {
            border-top: $border;
            color: #fff;
          }
        }
      }
      &:last-child {
        border-bottom: $border;
      }
    }
  }
  tbody {
    tr {
      height: $bodyHeight;
      &:has(.group) {
        height: $_bodyHeight;
        td {
          clip-path: polygon(0 #{$gap}, 100% #{$gap}, 100% 100%, 0 100%);
          padding-top: $gap;
          & > div {
            border-top: $border;
          }
          &:first-child {
            & > div {
              border-left: $border;
            }
          }
          &.group {
            div {
              border-bottom: $border;
            }
          }
        }
      }
      &:has(+ .has-group),
      &:last-child:not(.group) {
        td {
          div {
            border-bottom: $border;
          }
        }
      }
      td {
        background: var(--theme-color-1-10);
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
    }
  }
}
</style>
